import React from 'react';
import PropTypes from 'prop-types';

import { BackgroundRemovalView } from './background-removal-view';
import { ObjectsSelectionView } from './objects-selection-view';
import { ImageBackgroundGenerationView } from './image-background-generation-view';
import { VIEWS } from './model/constants';
import { useViewState } from './model/use-view-state';

export const ContentView = ({
  editingImage,
  repository,
  onApply,
  onClose,
  logger,
  i18n,
  perfMarker,
}) => {
  const {
    src: imageUrl, width: imageWidth, height: imageHeight,
  } = editingImage || {};

  const {
    // view states
    activeView,
    setActiveView,

    // APIs
    generateImageBackground,
    segmentationMasks,
    isFetchingSegmentations,

    // image states
    imageUrlWithoutBackground,
    imageUrlWithGeneratedBackground,
    getMaskValueAtPoint,
    selectedMasks,
    setSelectedMasks,
    selectedImageSrc,
    setSelectedImageSrc,
    fetchSegmentationError,
    maskValues,
  } = useViewState({
    imageUrl, imageWidth, imageHeight, repository, logger, perfMarker,
  });

  return (
    <>
      {activeView === VIEWS.BackgroundRemoval && (
        <BackgroundRemovalView
          originalImageUrl={imageUrl}
          imageUrlWithoutBackground={imageUrlWithoutBackground}
          setActiveView={setActiveView}
          i18n={i18n}
          logger={logger}
          onClose={onClose}
          errorMessage={fetchSegmentationError}
        />
      )}
      {activeView === VIEWS.ObjectsSelection && (
        <ObjectsSelectionView
          i18n={i18n}
          getMaskValueAtPoint={getMaskValueAtPoint}
          imageUrlWithoutBackground={imageUrlWithoutBackground}
          segmentationMasks={segmentationMasks}
          isFetchingSegmentations={isFetchingSegmentations}
          originalImageUrl={imageUrl}
          originalImageHeight={imageHeight}
          originalImageWidth={imageWidth}
          selectedMasks={selectedMasks}
          setSelectedMasks={setSelectedMasks}
          setSelectedImageSrc={setSelectedImageSrc}
          setActiveView={setActiveView}
          maskValues={maskValues}
          errorMessage={fetchSegmentationError}
          logger={logger}
        />
      )}
      {activeView === VIEWS.ImageBackgroundGeneration && (
        <ImageBackgroundGenerationView
          imageUrlWithoutBackground={selectedImageSrc || imageUrlWithoutBackground}
          imageUrlWithGeneratedBackground={imageUrlWithGeneratedBackground}
          generateImageBackground={generateImageBackground}
          onApply={onApply}
          onClose={onClose}
          i18n={i18n}
          logger={logger}
        />
      )}
    </>
  );
};

ContentView.propTypes = {
  editingImage: PropTypes.shape({
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  repository: PropTypes.shape({
    getImageSegmentations: PropTypes.func,
    generateImageBackground: PropTypes.func,
  }).isRequired,
  onApply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  logger: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
};

ContentView.defaultProps = {
};
